import React, { memo } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text } from '@redlink/components/atoms';

export const PreviewCategoryItem = memo(
  ({
    style,
    item,
    valueExtractor = (item) => item.title,
    onPress,
    isFocused = false,
  }) => {
    const { styles, colors } = useStyle();
    const value = valueExtractor(item);
    const color = isFocused ? colors.primary : colors.title;
    return (
      <TouchableOpacity
        {...{ onPress }}
        activeOpacity={0.6}
        style={[styles.container, style]}
      >
        <Text style={[styles.text, { color }]}>{value}</Text>
        <View style={[styles.indicator, { backgroundColor: color }]} />
      </TouchableOpacity>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {},
  text: {
    fontSize: 16,
    lineHeight: 32,
  },
  indicator: {
    width: 56,
    height: 3,
    borderRadius: 1.5,
  },
}));
